import moment from "moment";

const DATE_FORMAT = "DD/MM/YYYY";

/**
 * is appointment passed
 * @param {Date} date
 * @returns {bool}
 */
export function isDatePassed(date) {
  if (!date) return false;
  const today = this.$moment();
  const appTime = this.$moment(new Date(date));
  return today.isAfter(appTime);
}

/**
 * compare if same date
 * @param {Date} date1
 * @param {Date} date2
 * @returns {bool}
 */
export function compareDate(date1, date2) {
  if (moment(date1).isSame(date2, "day")) return true;
  return false;
}

/**
 * check if event is before today
 * @param {Date} date
 * @param {boolean} isBefore
 * @returns {boolean}
 */
export function isBeforeToday(date, isBefore = true) {
  if (isBefore) return new Date() > date;
  return new Date() < date;
}

/**
 * check if date is between two other dates
 * @param {Date} startDate
 * @param {Date} endDate
 * @param {Date} currentDate
 * @param {String} routeName
 * @returns {bool}
 */
export function isDateInRange(startDate, endDate, currentDate, routeName = "") {
  let min = moment(startDate).format(DATE_FORMAT);
  min = moment(min, DATE_FORMAT);
  if (routeName == "surgeries") {
    min = min.subtract(1, "M").format(DATE_FORMAT);
    min = moment(min, DATE_FORMAT);
  }
  let max = moment(endDate)
    .subtract(1, "M")
    .format(DATE_FORMAT);
  max = moment(max, DATE_FORMAT);
  let newD = moment(currentDate).format(DATE_FORMAT);
  newD = moment(newD, DATE_FORMAT);
  if (newD.isAfter(min) && newD.isBefore(max)) return true;
  return false;
}

/**
 * check if event is before today
 * @param {Number} id - day
 * @returns {Number} parse day
 */
export function parseDay(id) {
  let day = {
    1: 7,
    2: 1,
    3: 2,
    4: 3,
    5: 4,
    6: 5,
    7: 6
  };
  return day[id];
}

/**
 * get time format LT
 * @param {Date} date
 * @returns {String} HH:mm
 */
export function getTime(date) {
  return this.$moment(date).format("LT");
}

/**
 * get date format L
 * @param {Date} date
 * @returns {String}
 */
export function getDate(date) {
  return this.$moment(date).format("L");
}

/**
 * get duration between two dates in minutes
 * @param {Date} startDate
 * @param {Date} endDate
 * @returns {String}
 */
export function getDuration(startDate, endDate) {
  const start = this.$moment(startDate);
  const end = this.$moment(endDate);
  return end.diff(start, "m");
}
